/*** IMPORTS FROM imports-loader ***/


/**
 * GIS Server APIs
 * A powerful suite of mapping, geospatial and location-based APIs for your applications and services.
 *
 * OpenAPI spec version: v1.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CollectionResponsePointResponseReverseGeocodingResult', 'model/PointRequest', 'model/ResponseListString', 'model/ResponsePlaceResource', 'model/ResponseReverseGeocodingResult'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/CollectionResponsePointResponseReverseGeocodingResult'), require('../model/PointRequest'), require('../model/ResponseListString'), require('../model/ResponsePlaceResource'), require('../model/ResponseReverseGeocodingResult'));
  } else {
    // Browser globals (root is window)
    if (!root.GisServerApis) {
      root.GisServerApis = {};
    }
    root.GisServerApis.ReverseGeocodingApi = factory(root.GisServerApis.ApiClient, root.GisServerApis.CollectionResponsePointResponseReverseGeocodingResult, root.GisServerApis.PointRequest, root.GisServerApis.ResponseListString, root.GisServerApis.ResponsePlaceResource, root.GisServerApis.ResponseReverseGeocodingResult);
  }
}(this, function(ApiClient, CollectionResponsePointResponseReverseGeocodingResult, PointRequest, ResponseListString, ResponsePlaceResource, ResponseReverseGeocodingResult) {
  'use strict';

  /**
   * ReverseGeocoding service.
   * @module api/ReverseGeocodingApi
   * @version 1.0.0
   */

  /**
   * Constructs a new ReverseGeocodingApi. 
   * @alias module:api/ReverseGeocodingApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the getCommonPlaceCategoriesV1 operation.
     * @callback module:api/ReverseGeocodingApi~getCommonPlaceCategoriesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseListString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the types of places that are considered common.
     * @param {module:api/ReverseGeocodingApi~getCommonPlaceCategoriesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseListString}
     */
    this.getCommonPlaceCategoriesV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseListString;

      return this.apiClient.callApi(
        '/api/v1/location/reverse-geocode/place/categories/common', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPlaceByIdV1 operation.
     * @callback module:api/ReverseGeocodingApi~getPlaceByIdV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponsePlaceResource} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get details about a place by its OpenStreetMap ID.
     * @param {Number} placeId The OpenStreetMap ID of the place.
     * @param {Object} opts Optional parameters
     * @param {String} opts.lang Optional. Sets the language for the search result. The default value is \&quot;en\&quot;.
     * @param {module:api/ReverseGeocodingApi~getPlaceByIdV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponsePlaceResource}
     */
    this.getPlaceByIdV1 = function(placeId, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'placeId' is set
      if (placeId === undefined || placeId === null) {
        throw new Error("Missing the required parameter 'placeId' when calling getPlaceByIdV1");
      }


      var pathParams = {
        'placeId': placeId
      };
      var queryParams = {
        'lang': opts['lang'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponsePlaceResource;

      return this.apiClient.callApi(
        '/api/v1/location/place/{placeId}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPlaceCategoriesV1 operation.
     * @callback module:api/ReverseGeocodingApi~getPlaceCategoriesV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseListString} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the available place categories.
     * @param {module:api/ReverseGeocodingApi~getPlaceCategoriesV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseListString}
     */
    this.getPlaceCategoriesV1 = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseListString;

      return this.apiClient.callApi(
        '/api/v1/location/reverse-geocode/place/categories', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the searchForAreaV1 operation.
     * @callback module:api/ReverseGeocodingApi~searchForAreaV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseReverseGeocodingResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reverse geocode in a given area.
     * @param {String} area The Well Known Text (WKT) of the polygon feature to use as the search area.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.srid The SRID (coordinate system) in which to express the result. Defaults to 4326.
     * @param {String} opts.lang The language in which to express the result.
     * @param {Number} opts.searchRadius The maximun radius around the input point to search for places. Defaults to 200.
     * @param {module:model/String} opts.searchRadiusUnit The unit of measure in which the SearchRadius is expressed. Defaults to \&quot;Meter\&quot;.
     * @param {Number} opts.maxResults The maximun number of results to return. Defaults to 20.
     * @param {String} opts.placeCategories The categories of places to include in the result set. The default value is \&quot;Common\&quot;.
     * @param {String} opts.placeTypes Specified the types that should be included in the results. Defautls to empty.
     * @param {Boolean} opts.verboseResults Indicates whether the results should be verbose or not. When false, the results will hae fewer properties. Defaults to false.
     * @param {String} opts.reverseGeocodeTemplate Specified how to format the result property. Defaults to \&quot;[Distance] [DistanceUnit] [CardinalDirection] of [ResultDescription]\&quot;
     * @param {Boolean} opts.includeIntersections Indicates whether to include the interections in the result or not. Defaults to false.
     * @param {module:model/String} opts.distanceUnit The unit of measure in which the distance is expressed. Defaults to \&quot;Meter\&quot;.
     * @param {module:api/ReverseGeocodingApi~searchForAreaV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseReverseGeocodingResult}
     */
    this.searchForAreaV1 = function(area, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'area' is set
      if (area === undefined || area === null) {
        throw new Error("Missing the required parameter 'area' when calling searchForAreaV1");
      }


      var pathParams = {
      };
      var queryParams = {
        'area': area,
        'Srid': opts['srid'],
        'Lang': opts['lang'],
        'SearchRadius': opts['searchRadius'],
        'SearchRadiusUnit': opts['searchRadiusUnit'],
        'MaxResults': opts['maxResults'],
        'PlaceCategories': opts['placeCategories'],
        'PlaceTypes': opts['placeTypes'],
        'VerboseResults': opts['verboseResults'],
        'ReverseGeocodeTemplate': opts['reverseGeocodeTemplate'],
        'IncludeIntersections': opts['includeIntersections'],
        'DistanceUnit': opts['distanceUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseReverseGeocodingResult;

      return this.apiClient.callApi(
        '/api/v1/location/reverse-geocode/query', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the searchForPointV1 operation.
     * @callback module:api/ReverseGeocodingApi~searchForPointV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseReverseGeocodingResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reverse geocode a point.
     * @param {Number} lat The latitude of the point.
     * @param {Number} lon The longitude of the point.
     * @param {Object} opts Optional parameters
     * @param {Number} opts.srid The SRID (coordinate system) in which to express the result. Defaults to 4326.
     * @param {String} opts.lang The language in which to express the result.
     * @param {Number} opts.searchRadius The maximun radius around the input point to search for places. Defaults to 200.
     * @param {module:model/String} opts.searchRadiusUnit The unit of measure in which the SearchRadius is expressed. Defaults to \&quot;Meter\&quot;.
     * @param {Number} opts.maxResults The maximun number of results to return. Defaults to 20.
     * @param {String} opts.placeCategories The categories of places to include in the result set. The default value is \&quot;Common\&quot;.
     * @param {String} opts.placeTypes Specified the types that should be included in the results. Defautls to empty.
     * @param {Boolean} opts.verboseResults Indicates whether the results should be verbose or not. When false, the results will hae fewer properties. Defaults to false.
     * @param {String} opts.reverseGeocodeTemplate Specified how to format the result property. Defaults to \&quot;[Distance] [DistanceUnit] [CardinalDirection] of [ResultDescription]\&quot;
     * @param {Boolean} opts.includeIntersections Indicates whether to include the interections in the result or not. Defaults to false.
     * @param {module:model/String} opts.distanceUnit The unit of measure in which the distance is expressed. Defaults to \&quot;Meter\&quot;.
     * @param {module:api/ReverseGeocodingApi~searchForPointV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ResponseReverseGeocodingResult}
     */
    this.searchForPointV1 = function(lat, lon, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'lat' is set
      if (lat === undefined || lat === null) {
        throw new Error("Missing the required parameter 'lat' when calling searchForPointV1");
      }

      // verify the required parameter 'lon' is set
      if (lon === undefined || lon === null) {
        throw new Error("Missing the required parameter 'lon' when calling searchForPointV1");
      }


      var pathParams = {
        'lat': lat,
        'lon': lon
      };
      var queryParams = {
        'Srid': opts['srid'],
        'Lang': opts['lang'],
        'SearchRadius': opts['searchRadius'],
        'SearchRadiusUnit': opts['searchRadiusUnit'],
        'MaxResults': opts['maxResults'],
        'PlaceCategories': opts['placeCategories'],
        'PlaceTypes': opts['placeTypes'],
        'VerboseResults': opts['verboseResults'],
        'ReverseGeocodeTemplate': opts['reverseGeocodeTemplate'],
        'IncludeIntersections': opts['includeIntersections'],
        'DistanceUnit': opts['distanceUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = [];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = ResponseReverseGeocodingResult;

      return this.apiClient.callApi(
        '/api/v1/location/reverse-geocode/{lat},{lon}', 'GET',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the searchForPointsV1 operation.
     * @callback module:api/ReverseGeocodingApi~searchForPointsV1Callback
     * @param {String} error Error message, if any.
     * @param {module:model/CollectionResponsePointResponseReverseGeocodingResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Reverse geocode each point in a collection (up to 1,000 points maximum).
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/PointRequest>} opts.body A list of points that you want reverse geocoded.
     * @param {Number} opts.srid The SRID (coordinate system) in which to express the result. Defaults to 4326.
     * @param {String} opts.lang The language in which to express the result.
     * @param {Number} opts.searchRadius The maximun radius around the input point to search for places. Defaults to 200.
     * @param {module:model/String} opts.searchRadiusUnit The unit of measure in which the SearchRadius is expressed. Defaults to \&quot;Meter\&quot;.
     * @param {Number} opts.maxResults The maximun number of results to return. Defaults to 20.
     * @param {String} opts.placeCategories The categories of places to include in the result set. The default value is \&quot;Common\&quot;.
     * @param {String} opts.placeTypes Specified the types that should be included in the results. Defautls to empty.
     * @param {Boolean} opts.verboseResults Indicates whether the results should be verbose or not. When false, the results will hae fewer properties. Defaults to false.
     * @param {String} opts.reverseGeocodeTemplate Specified how to format the result property. Defaults to \&quot;[Distance] [DistanceUnit] [CardinalDirection] of [ResultDescription]\&quot;
     * @param {Boolean} opts.includeIntersections Indicates whether to include the interections in the result or not. Defaults to false.
     * @param {module:model/String} opts.distanceUnit The unit of measure in which the distance is expressed. Defaults to \&quot;Meter\&quot;.
     * @param {module:api/ReverseGeocodingApi~searchForPointsV1Callback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollectionResponsePointResponseReverseGeocodingResult}
     */
    this.searchForPointsV1 = function(opts, callback) {
      opts = opts || {};
      var postBody = opts['body'];


      var pathParams = {
      };
      var queryParams = {
        'Srid': opts['srid'],
        'Lang': opts['lang'],
        'SearchRadius': opts['searchRadius'],
        'SearchRadiusUnit': opts['searchRadiusUnit'],
        'MaxResults': opts['maxResults'],
        'PlaceCategories': opts['placeCategories'],
        'PlaceTypes': opts['placeTypes'],
        'VerboseResults': opts['verboseResults'],
        'ReverseGeocodeTemplate': opts['reverseGeocodeTemplate'],
        'IncludeIntersections': opts['includeIntersections'],
        'DistanceUnit': opts['distanceUnit'],
      };
      var collectionQueryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['API Key', 'Client Credentials', 'Resource Owner Password'];
      var contentTypes = ['application/json-patch+json', 'application/json', 'text/json', 'application/_*+json'];
      var accepts = ['text/plain', 'application/json', 'text/json'];
      var returnType = CollectionResponsePointResponseReverseGeocodingResult;

      return this.apiClient.callApi(
        '/api/v1/location/reverse-geocode/multi', 'POST',
        pathParams, queryParams, collectionQueryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));

